
import React from 'react';
import EnergyCards from './energy/EnergyCards';
import WaterCards from './water/WaterCards';
import GasCards from './gas/GasCards';
import CardVisibilityManager from './CardVisibilityManager';
import { useStatsCardData } from './useStatsCardData';

const StatsGrid: React.FC<{ isEditMode?: boolean }> = ({ isEditMode = false }) => {
  const { statCards } = useStatsCardData();
  
  // Only show cards that are visible (or don't have visibility explicitly set to false)
  const visibleCards = statCards.filter(card => card.visible !== false);
  
  // Check if any cards are hidden
  const hasHiddenCards = statCards.some(card => card.visible === false);

  return (
    <>
      {isEditMode && hasHiddenCards && (
        <div className="flex justify-end mb-2">
          <CardVisibilityManager />
        </div>
      )}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 mb-8">
        {/* Only render if there are visible cards */}
        {visibleCards.length > 0 && (
          <>
            {/* Energy KPI Cards */}
            <EnergyCards isEditMode={isEditMode} />
            
            {/* Water KPI Cards */}
            <WaterCards isEditMode={isEditMode} />
            
            {/* Gas KPI Cards */}
            <GasCards isEditMode={isEditMode} />
          </>
        )}
      </div>
    </>
  );
};

export default StatsGrid;
